import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const NotificationsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NotificationsCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notificationsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"grouped"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"StringValue","value":"all","block":false}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"NotificationsCount","document":NotificationsCountDocument}} as const;
export type NotificationsCountQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type NotificationsCountQuery = (
  { __typename: 'Query' }
  & Pick<Types.Query, 'notificationsCount'>
);

/**
 * __useNotificationsCountQuery__
 *
 * To run a query within a React component, call `useNotificationsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotificationsCountQuery(
  baseOptions?: TrelloQueryHookOptions<
    NotificationsCountQuery,
    NotificationsCountQueryVariables
  >,
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: NotificationsCountDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    NotificationsCountQuery,
    NotificationsCountQueryVariables
  >(NotificationsCountDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useNotificationsCountLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    NotificationsCountQuery,
    NotificationsCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    NotificationsCountQuery,
    NotificationsCountQueryVariables
  >(NotificationsCountDocument, options);
}
export type NotificationsCountQueryHookResult = ReturnType<
  typeof useNotificationsCountQuery
>;
export type NotificationsCountLazyQueryHookResult = ReturnType<
  typeof useNotificationsCountLazyQuery
>;
export type NotificationsCountQueryResult = Apollo.QueryResult<
  NotificationsCountQuery,
  NotificationsCountQueryVariables
>;
